'use strict';

var React = require('react'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    getThumbnailUrl = require('../utils/getThumbnailUrl'),
    ImagePlaceholderCache = require('../utils/ImagePlaceholderCache'),
    { PropTypes, Children } = React;

require('./AboutSectionCarousel.less');

var AboutSectionCarousel = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  propTypes: {
    hidden: PropTypes.bool,
    active: PropTypes.bool.isRequired,
    type: PropTypes.oneOf(['stamps', 'zines']).isRequired
  },

  getCSSModifiers() {
    const { hidden, active, type } = this.props;

    return {
      hidden: hidden,
      inactive: !active,
      [type]: true
    };
  },

  render() {
    return (
      <div className={this.getClassName()}>
        {Children.map(this.props.children, this.wrapChild)}
      </div>
    );
  },

  wrapChild(child, key) {
    if (!child) {
      return;
    }

    return (
      <div className='AboutSectionCarousel-itemWrapper' key={key}>
        {child}
      </div>
    );
  }
});


class NodeImagePlaceholderCache {
  getDataURLForSize({ width, height }: size) {
    console.log('Calling NodeImagePlaceholderCache');
    return '';
  }
}

// We know the exact image size but we can't set
// explicit size in CSS because we want to scale
// down to parent's width. To avoid jumps when image
// has loaded, we'll use a placeholder cache with
// transparent canvas data URIs for given image size.

var _placeholderCache =
  (typeof navigator !== 'undefined')
  ? new ImagePlaceholderCache()
  : new NodeImagePlaceholderCache;

var AboutSectionCarouselImage = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  className: 'AboutSectionCarousel-image',

  propTypes: {
    imageUrl: PropTypes.string.isRequired,
    imageSize: PropTypes.shape({
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired
    }).isRequired,
    faded: PropTypes.bool
  },

  getCSSModifiers() {
    return {
      faded: this.props.faded
    };
  },

  getInitialState() {
    const { imageSize } = this.props;
    return {
      src: _placeholderCache.getDataURLForSize(imageSize)
    };
  },

  componentDidMount() {
    this.setSrcFromProps(this.props);
  },

  componentWillReceiveProps(nextProps) {
    this.setSrcFromProps(nextProps);
  },

  setSrcFromProps(props) {
    const { imageUrl, imageSize } = props;
    const devicePixelRatio = (typeof window !== 'undefined') ? window.devicePixelRatio : 1;

    this.setState({
      src: getThumbnailUrl({ url: imageUrl }, {
        mode: 'preview',
        width: imageSize.width * Math.round(devicePixelRatio),
        height: imageSize.height * Math.round(devicePixelRatio)
      })
    });
  },

  render() {
    const { src } = this.state;
    return (
      <div className={this.getClassName()}>
        <img src={src} />
      </div>
    );
  }
});

module.exports = AboutSectionCarousel;
module.exports.Image = AboutSectionCarouselImage;



/** WEBPACK FOOTER **
 ** ./organisms/AboutSectionCarousel.jsx
 **/